export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-indent-more-bb15dc3cbf28609e9095640b8e80c2e3.svg";